<template>
    <div>
        <div class="container is-max-widescreen p-5">
            <LoginHeader />
        
            <div v-if="twofaActivated===false">
                <div class="list-panel-header columns is-desktop has-background-info-dark px-3 has-text-white mb-0 mx-0">
                    <div class="column has-text-centered has-text-left-desktop">
                        <span class="is-size-5">{{$t('google_two_step_verification_setup')}}</span>
                    </div>
                    <div class="column has-text-centered has-text-right-desktop">
                        <a class="has-background-info-dark btnBorder helpLink" type="is-ghost" href="LoginTwoFactorHelp" target="_blank">
                        <span class="is-size-6"><i class="mdi mdi-alert-circle pr-1"></i>{{$t('help')}}</span>
                        </a> 
                    </div>
                </div>
                <div class="columns is gapless has-background-white mx-0 pt-5">
                    <div class="column ml-3 has-border-right-light">
                        <span class="is-size-4 numberSpan px-2 mr-1">1</span>
                        <span class="is-size-4 fw600">{{$t('download_the_app')}}</span>
                        <p class="pt-1 pb-4">{{$t('download_the_app_text')}}</p>
                        <div>
                            <a href="https://apps.apple.com/tr/app/google-authenticator/id388497605?l" target="_blank">
                                <img src="/static/images/iyspanel-appstore-logo.png" alt="">
                            </a>
                        </div>
                        <div>
                            <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=tr&gl" target="_blank">
                                <img src="/static/images/iyspanel-googleplaystore-logo.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="column ml-3 has-border-right-light ">
                        <span class="is-size-4 numberSpan px-2 mr-1">2</span>
                        <span class="is-size-4 fw600">{{$t('scan_qr_code')}}</span>
                        <p class="pt-1 pb-4">{{$t('scan_qr_code_text')}}</p>
                        <div class="columns mx-0">
                            <div class="column p-0 has-text-centered">
                                <img :src="`${initialize2faData.qrImageDownloadLink}`" alt="qr kod">
                            </div>
                        </div>
                            <label class="has-text-weight-bold " for="">{{$t('recovery_code')}}</label>
                            <div class="inputStyle">
                            <p id="recoveryCode">{{initialize2faData.twofaSecret}}</p>
                            <span class="mdi mdi-content-copy copyIcon pr13" @click="copyToCode()"></span>
                            </div>
                        <p class ="has-background-primary-light p-3 fs13">{{$t('recovery_code_text')}}</p>
                    </div>
                    <div class="column ml-3">
                        <span class="is-size-4 numberSpan px-2 mr-1">3</span>
                        <span class="is-size-4 fw600">{{$t('enter_verification_code')}}</span>
                        <p class="pt-1 pb-4">{{$t('verification_code_text')}}</p>
                        <div class="column warningDiv py-2">
                            <p><i class="mdi mdi-alert-circle mr-1"></i> Lütfen Dikkat</p>
                        </div>
                        <div class="column pinkCol mb-4">
                            <p class="fs13 pinkColText pt-1">{{$t('download_pdf_text')}}</p>
                            <b-button @click="pdfDownload()" type="is-ghost" class="btnBorder pl-0 pinkColBtn pt-3">{{$t('download_pdf')}}</b-button>
                        </div>
                        <b-field>
                            <b-input v-model="googleAuthenticatorCode" placeholder="Google Authenticator Kodu"></b-input>
                        </b-field>
                        <b-button type="is-primary" @click="activate_2faF()">{{$t('activate_verification_code')}}</b-button>
                    </div>
                </div>
            </div>

           
            <div v-else-if="twofaActivated===true" class="container contDiv has-text-centered is-max-desktop p-5 has-background-white">
                <span class="is-size-4 has-text-weight-bold">{{$t('two_step_verification_code')}}</span>
                <p class="pt-4 ">{{$t('two_step_verification_text')}}</p>
                <div class="pt-3">
                    <input v-model="input1" maxlength="1" id="input1" class="inputNumberStyle mr-1" @keyup="inputFocus($event)" onkeypress='return event.charCode >= 48 && event.charCode <= 57' >
                    <input  @keyup="inputFocus($event)" v-model="input2" maxlength="1" class="inputNumberStyle mr-1"  onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                    <input  @keyup="inputFocus($event)" v-model="input3" maxlength="1" class="inputNumberStyle mr-1" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                    <input  @keyup="inputFocus($event)" v-model="input4" maxlength="1" class="inputNumberStyle mr-1" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                    <input  @keyup="inputFocus($event)" v-model="input5" maxlength="1" class="inputNumberStyle mr-1" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                    <input  @keyup="inputFocus($event)" v-model="input6" maxlength="1" class="inputNumberStyle mr-1" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>

                </div>
                <div class="pt-4">
                <a class="colorGray cursorPointer" href="LoginTwoFactorHelp" target="_blank" >Kod Çalışmıyor mu?</a>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import LoginHeader from './LoginHeader';
import {mapActions} from 'vuex'
import { NotificationProgrammatic as Notification } from 'buefy'
export default {
    name:"LoginTwoFactor",
    components: {
        LoginHeader
    },
    data() {
        return {
            input1:"",
            input2:"",
            input3:"",
            input4:"",
            input5:"",
            input6:"",
            auth_code:"",
            initialize2faData:{
                qrPdfDownloadLink:"",
                qrImageDownloadLink:"",
                twofaSecret:"",
                twofaqrPath:""
            },
            loginForm:{
                email:'',
                password:''
            },
            twofaActivated:"",
            googleAuthenticatorCode:""
        }
    },
    methods: {
    ...mapActions(['initialize_2fa','activate_2fa','authenticateUser_2fa_finalize']),
        inputFocus(e){
            var target = e.srcElement;
            var maxLength = parseInt(target.attributes["maxlength"].value, 10);
            var myLength = target.value.length;
            if (myLength >= maxLength) {
                var next = target;
                while (next = next.nextElementSibling) {
                    if (next == null){
                        break;
                    }
                    if (next.tagName.toLowerCase() == "input") {
                        next.focus();
                        break;
                    }
                }
            }
            else if (myLength == 0) {
                var next = target;
                    while (next = next.previousElementSibling) {
                        if (next == null){
                           
                            break;
                        }
                        if (next.tagName.toLowerCase() == "input") {
                            next.focus();
                            break;
                        }
                    }

            }

            this.auth_code=this.input1+this.input2+this.input3+this.input4+this.input5+this.input6
            if(this.auth_code.length==6){
                // this.input1=""
                // this.input2=""
                // this.input3=""
                // this.input4=""
                // this.input5=""
                // this.input6=""

                var authenticator_code={}
                var loginForm={}
                var loginForm=this.loginForm
                authenticator_code=this.auth_code
                loginForm=JSON.parse(localStorage.getItem("loginData"))
                loginForm={loginForm,authenticator_code}

                this.authenticateUser_2fa_finalize(loginForm).then((response) => {
                console.log('--authenticateUser_2fa_finalize success response')
                console.log(response)
                if(response.status.code == '0'){
                     this.$router.push('/')
                }
                else{
                    this.input1=""
                    this.input2=""
                    this.input3=""
                    this.input4=""
                    this.input5=""
                    this.input6=""
                    document.getElementById("input1").focus();
                    
                }
                }).catch(e => {
                console.log('--authenticateUser_2fa_finalize Error')
                console.log(e)
                })
                        
                }
        },
        initialize_2faF(){
            this.loginForm=JSON.parse(localStorage.getItem("loginData"))
            this.initialize_2fa(this.loginForm).then((response) => {
            console.log('--initialize_2fa success response')
            console.log(response)
            if(response.status.code == '0'){
                this.$buefy.dialog.alert({
                    title: 'İki Adımlı Doğrulama Hakkında',
                    message: 'İYS Panel hesabınızın daha güvenli olmasını sağlayacak Google 2 Adımlı Doğrulama yöntemine geçiyoruz.<br><br>İYS Panel’de Oturum açarken parolanızın yanında mobil cihazınıza kurulan “<b>Google Authenticator</b>” uygulamasının ürettiği kodu da kullanmanız gerekecek. Böylece iki adımlı doğrulama hesabına yalnızca sizin erişebildiğinize emin olmanızı sağlayacak.<br><br>Konu ile ilgili detaylı bilgiye “<b>Yardım</b>” sayfamızdan ya da “<b>0850 483 0 444</b>” numaralı destek hattımızı arayarak ulaşabilirsiniz.',
                    type: 'is-danger',
                    hasIcon: true,
                    type: 'is-danger',
                    ariaRole: 'alertdialog',
                    ariaModal: true,
                    confirmText: 'Tamam',
                    type: 'is-danger',
                    
                })
                this.initialize2faData.qrPdfDownloadLink=response.content.qr_pdf_download_link
                this.initialize2faData.qrImageDownloadLink=response.content.qr_image_download_link
                this.initialize2faData.twofaSecret=response.content.twofa_secret
                this.initialize2faData.twofaqrPath=response.content.twofa_qr_path
            }
            }).catch(e => {
            console.log('--initialize_2fa Error')
            console.log(e)
            })
        },
        pdfDownload(){
            window.open(this.initialize2faData.qrPdfDownloadLink);
        },
        activate_2faF(){
            if(this.googleAuthenticatorCode.length>0){
                var authenticator_code={}
                var loginForm={}
                var loginForm=this.loginForm
                authenticator_code=this.googleAuthenticatorCode
                loginForm=JSON.parse(localStorage.getItem("loginData"))
                loginForm={loginForm,authenticator_code}
                this.activate_2fa(loginForm).then((response) => {
                console.log('--activate_2fa success response')
                console.log(response)
                if(response.status.code == '0'){
                this.$buefy.dialog.alert({
                        title: 'Doğrulama Kodunuz Aktif Edildi',
                        message: 'Doğrulama kodunuz aktif edilmiştir. Anasayfaya yönlediriliyorsunuz.',
                        type: 'is-success',
                        hasIcon: true,
                        ariaRole: 'alertdialog',
                        ariaModal: true,
                        confirmText: 'Tamam',
                        onConfirm: () => {
                            this.$router.push('/')
                        }
                    })
                }
                }).catch(e => {
                console.log('--activate_2fa Error')
                console.log(e)
                })
            }
            else{
                Notification.open({
                message: 'Lütfen google authenticator kodunu giriniz',
                type: 'is-danger',
                
            })
            }
        },
        twofaActivatedControl(){
            this.twofaActivated=JSON.parse(localStorage.getItem("twofaActivated"))
            console.log(this.twofaActivated);
            if(this.twofaActivated===false){
                this.initialize_2faF()
            }
        },
        copyToCode(){
            var alan = document.getElementById('recoveryCode').innerText;
            var textAlani = document.createElement('TEXTAREA');
            textAlani.value = alan;
            console.log(textAlani.value);
            document.body.appendChild(textAlani);
            textAlani.select();
            document.execCommand('copy');
            textAlani.style.display = 'none';
            Notification.open({
                message: 'Kopyalandı',
                type: 'is-success',
                
            })

        }
        
    },
    created(){
        this.twofaActivatedControl()
        this.$root.$refs.LoginTwoFactor= this
    },
}
</script>
<style scoped>
    .list-panel-header{
        border-radius: 16px 16px 0 0;
        min-height: 60px;
    }
    .numberSpan{
        background-color: rgba(11, 99, 206, 0.1);
        color:#0B63CE;
    }
    .fw600{
        font-weight: 600;
    }
    .btnBorder{
        border: 0;
    }
    .helpLink{
        color: #ffffff;
    }
    .pinkCol{
        background-color: rgba(225, 96, 77, 0.15);
        padding: 16px 12px 12px 16px;
    }
    .warningDiv{
        background-color: #DA1414;
        color: #ffffff;
        font-size: 18px;
        font-weight: 600;
        padding-left: 16px;
    }
    .pinkColText{
        color: #DA1414;
        font-size: 13px;
        line-height: 18px;
    }
    .pinkColBtn{
        background-color: rgba(0, 0, 0, 0);
        color: #09101D;
        font-weight: 600;
    }
    .fs13{
        font-size: 13px;
    }
    .inputStyle{
        height: 40px;
        color:#DA1414;
        background-color: #F6F8FB;
        border: 0;
        padding-left: 13px;
        font-size: 15px;
        padding-top: 9px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 8px;
    }
    .pr13{
        padding-right: 13px;
    }
    .inputNumberStyle{
        width: 48px;
        height: 48px;
        background-color: #F4F6F9;
        box-sizing: border-box;
        border: 1px solid #DADEE3;
        text-align: center;
        flex: none;
        order: 0;
        border-radius: 8px;
        font-size: 28px;
    }
    .containerDiv{
        max-width: 446px;
        height: 282px;
    }
    .colorGray{
        color: #858C94;
    }
    .card-header{
        background-color: #EDF9F0;
        height: 56px;
        border-bottom: 1px solid #287D3C;
    }
    .contDiv{
        max-width: 450px;
        border-radius: 8px;
        box-shadow: 0px 17.5px 70px rgba(0, 0, 0, 0.12);
    }
    .copyIcon{
        color: #858C94;
        cursor: pointer;
    }
    .cursorPointer{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/LoginTwoFactor.vue